import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import ProgressBar from "./ProgressBar";

// Un seul loader à l'écran : un composant enveloppé par withLoader et rendu à
// l'intérieur d'un autre composant enveloppé réutilise le loader du parent
// au lieu d'afficher le sien (sinon deux loaders se superposent).
const LoaderContext = createContext(null);

const withLoader = (WrappedComponent) => {
  const WithLoader = (props) => {
    const parentLoader = useContext(LoaderContext);
    const [loading, setLoading] = useState(false);

    const startLoading = useCallback(() => setLoading(true), []);
    const stopLoading = useCallback(() => setLoading(false), []);
    const loader = useMemo(
      () => ({ startLoading, stopLoading }),
      [startLoading, stopLoading]
    );

    if (parentLoader) {
      return (
        <WrappedComponent
          {...props}
          startLoading={parentLoader.startLoading}
          stopLoading={parentLoader.stopLoading}
        />
      );
    }

    return (
      <LoaderContext.Provider value={loader}>
        <div>
          {loading && <ProgressBar />}
          <WrappedComponent
            {...props}
            startLoading={startLoading}
            stopLoading={stopLoading}
          />
        </div>
      </LoaderContext.Provider>
    );
  };
  return WithLoader;
};

export default withLoader;
